import { render, staticRenderFns } from "./MatchPrincipalAccordionTable.vue?vue&type=template&id=100934e9&scoped=true&"
import script from "./MatchPrincipalAccordionTable.vue?vue&type=script&lang=ts&"
export * from "./MatchPrincipalAccordionTable.vue?vue&type=script&lang=ts&"
import style0 from "./MatchPrincipalAccordionTable.vue?vue&type=style&index=0&id=100934e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100934e9",
  null
  
)

export default component.exports